import * as tslib_1 from "tslib";
import { throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { BaseService } from '../base.service';
import { OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
var PolipayReconSettlementResultService = /** @class */ (function (_super) {
    tslib_1.__extends(PolipayReconSettlementResultService, _super);
    function PolipayReconSettlementResultService(http) {
        var _this = _super.call(this, 'polipay-recon-settlement-result', http) || this;
        _this.http = http;
        return _this;
    }
    PolipayReconSettlementResultService.prototype.ngOnInit = function () {
    };
    PolipayReconSettlementResultService.prototype.getAllBankResultByPaging = function (searchCondition, paging) {
        if (!searchCondition) {
            searchCondition = '';
        }
        var embeddedStr = '&embedded=transaction,bnz-data,kiwi-data&f_errorCode=0&f_errorCode_op=IN';
        return this.http.get(this.url + "?" + paging.getPagingStr() + (embeddedStr + searchCondition) + "&sort=id,desc").pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    PolipayReconSettlementResultService.prototype.getAllBankIssueResultByPaging = function (searchCondition, paging) {
        if (!searchCondition) {
            searchCondition = '';
        }
        var embeddedStr = '&embedded=transaction,bnz-data,kiwi-data&f_errorCode=B110&f_errorCode=B210&f_errorCode=B310&f_errorCode=K110&f_errorCode=K210&f_errorCode=K310';
        return this.http.get(this.url + "?" + paging.getPagingStr() + (embeddedStr + searchCondition) + "&sort=id,desc").pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    PolipayReconSettlementResultService.prototype.getAllBankRfResultByPaging = function (searchCondition, paging) {
        if (!searchCondition) {
            searchCondition = '';
        }
        var embeddedStr = '&embedded=transaction,statement-item&f_statementItem.sub_transaction_type=GatewayNppReceivableRefund&f_errorCode=0';
        return this.http.get(this.url + "?" + paging.getPagingStr() + (embeddedStr + searchCondition) + "&sort=id,desc").pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    PolipayReconSettlementResultService.prototype.getAllBankRfIssueResultByPaging = function (searchCondition, paging) {
        if (!searchCondition) {
            searchCondition = '';
        }
        var embeddedStr = '&embedded=transaction,statement-item&f_errorCode=B617&f_errorCode=B717&f_errorCode=B917';
        return this.http.get(this.url + "?" + paging.getPagingStr() + (embeddedStr + searchCondition) + "&sort=id,desc").pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    PolipayReconSettlementResultService.prototype.getAllBankAbResultByPaging = function (searchCondition, paging) {
        if (!searchCondition) {
            searchCondition = '';
        }
        var embeddedStr = '&embedded=transaction,statement-item&f_statementItem.sub_transaction_type=GatewayNppDirectCredit&f_errorCode=0';
        return this.http.get(this.url + "?" + paging.getPagingStr() + (embeddedStr + searchCondition) + "&sort=id,desc").pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    PolipayReconSettlementResultService.prototype.getAllBankAbIssueResultByPaging = function (searchCondition, paging) {
        if (!searchCondition) {
            searchCondition = '';
        }
        var embeddedStr = '&embedded=transaction,statement-item&f_errorCode=B317&f_errorCode=B417&f_errorCode=B517&f_errorCode=B1017';
        return this.http.get(this.url + "?" + paging.getPagingStr() + (embeddedStr + searchCondition) + "&sort=id,desc").pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    PolipayReconSettlementResultService.prototype.getAllCouponByBusinessIdByPaging = function (searchCondition, businessId, sortOprions, paging) {
        if (!searchCondition) {
            searchCondition = '';
        }
        var idStr = '&f_businessId_op==&f_businessId=' + businessId;
        var sortStr = sortOprions.getSortString();
        // this.embeddedStr = '&embedded=coupons-promo';
        return this.http.get(this.url + "/get-coupons" + sortStr + paging.getPagingStr() + (this.embeddedStr + idStr + searchCondition) + "&sort=id,desc").pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    PolipayReconSettlementResultService.prototype.createRecon = function (data) {
        return this.http.post("https://api-admin-v2.latipay.net/apm/autojob/create", data).pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    PolipayReconSettlementResultService.prototype.getAllLatipayByPaging = function (searchCondition, paging) {
        var idSortStr = '&sort=id,desc';
        if (!searchCondition) {
            searchCondition = '';
        }
        var str = '&f_type_op==&f_type=1';
        return this.http.get(this.url + "?" + paging.getPagingStr() + (this.embeddedStr + searchCondition + idSortStr)).pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    PolipayReconSettlementResultService.prototype.getAllLatipayByMerchantIdByPaging = function (merchantId, searchCondition, paging) {
        var idSortStr = '&sort=id,desc';
        if (!searchCondition) {
            searchCondition = '';
        }
        var str = '&f_merchantId_op==&f_merchantId=' + merchantId;
        return this.http.get(this.url + "?" + paging.getPagingStr() + (this.embeddedStr + searchCondition + idSortStr + str)).pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    PolipayReconSettlementResultService.prototype.get = function (id) {
        var embeddedStr = '&embedded=transaction,bnz-data,kiwi-data';
        var str = embeddedStr ? id + "?" + embeddedStr : id;
        return this.http.get(this.url + "/" + str).pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    PolipayReconSettlementResultService.prototype.updateStatus = function (id, value) {
        return this.http.put(this.url + "/update-status/" + id, value).pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    PolipayReconSettlementResultService.prototype.autoRecon = function () {
        return this.http.get(this.url + "/auto-recon").pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    return PolipayReconSettlementResultService;
}(BaseService));
export { PolipayReconSettlementResultService };
